RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const widgetTypes = RivalIQ.enums.widgetTypes;

    function hasAudienceData(presenceData) {
        return !_.isEmpty(_.get(presenceData, ['period2', 'audience_city']));
    }

    const InstagramSectionWidget = RivalIQ.views.LayoutView.mixin({
        template: '#insightsVerticalNormalizeHeightsTemplate2',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            top: '.x-top',
            bottom: '.x-bottom'
        },

        ui: {
            noDataMsgContainer: '.insights-no-data-msg-container',
            noDataMsg: '.insights-no-data-msg',
            dashboardRegions: '.dashboard-regions'
        },

        initialize: function () {
            const me = this;

            me.collection = me.dashboardModel.getWidgets();
        },

        loadData: function () {
            const me = this;

            return App.utils.constructInsightsCompanyDataFetch(me.getProps())
                .then(function (cd) {
                    const company = cd.get(me.dashboardModel.getProp('companyId')).toJSON();
                    me.presenceData = RivalIQ.utils.companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, company);
                });
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            me.collection.each(function (widget) {
                const region = widget.getRegion();
                me[region].showWidget(widget);
            });
        },

        onRenderLoaded: function () {
            const me = this;
            me.toggleViews();
        },

        toggleViews: function () {
            const me = this;

            // Look for one of the audience fields to see if we have data.
            const audienceDataAvailable = hasAudienceData(me.presenceData);
            const earliestAudienceDataDate = _.get(me.presenceData, ['presence', 'earliest_audience_data_date']);

            if (!audienceDataAvailable && earliestAudienceDataDate && moment.utc(me.getProp('timePeriod').mainPeriodEnd).isBefore(earliestAudienceDataDate)) {
                me.ui.dashboardRegions.hide();
                me.ui.noDataMsg.text(`No data in time periods prior to ${moment.utc(earliestAudienceDataDate).format('L')} (when you connected Instagram Insights to Rival IQ)`);
                me.ui.noDataMsgContainer.show();
            } else {
                me.ui.dashboardRegions.show();
                me.ui.noDataMsgContainer.hide();
            }
        }
    });

    const InstagramFollowerAgeGender = widgets.InstagramFollowerAgeGender = App.widgets.InsightsSectionWidget.extend({
        title: RivalIQ.strings.instagram_insights_follower_age_gender_widget_title,
        view: InstagramSectionWidget,
        description: RivalIQ.strings.instagram_insights_followers_age_gender_widget_description,

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            let widgets = [
                {
                    instanceId: 'insta-gender-donut',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'gender_age',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.INSTAGRAM_INSIGHTS
                    },
                    region: 'top'
                },
                {
                    instanceId: 'insta-age-gender',
                    widgetId: widgetTypes.INSIGHTS_AGE_GENDER_DISTRIBUTION,
                    metricGroupType: 'insta_followers',
                    props: {
                        companyId: props.companyId,
                        height: 135
                    },
                    region: 'bottom'
                }
            ];

            if (props.onlyInstanceId) {
                widgets = _.filter(widgets, {
                    instanceId: props.onlyInstanceId
                });
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_FOLLOWER_AGE_GENDER, InstagramFollowerAgeGender);

    const InstagramFollowerLocations = widgets.InstagramFollowerLocations = App.widgets.InsightsSectionWidget.extend({
        title: RivalIQ.strings.instagram_insights_follower_locations_widget_title,
        view: InstagramSectionWidget,
        description: RivalIQ.strings.instagram_insights_follower_locations_widget_description,

        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.CSV
        ],

        csvExportProps: function (props) {
            const me = this;

            return {
                type: 'insights_demographics',
                companyId: props.companyId,
                sourceMask: RivalIQ.enums.sourceDetails[props.source].sourceMask,
                demographicTypes: ['country', 'city'],
                timePeriod: me.getProp('timePeriod')
            };
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            let widgets = [
                {
                    instanceId: 'insta-countries',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'country',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.INSTAGRAM_INSIGHTS
                    },
                    region: 'top'
                },
                {
                    instanceId: 'insta-cities',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'city',
                        companyId: props.companyId
                    },
                    region: 'bottom'
                }
            ];

            if (props.onlyInstanceId) {
                widgets = _.filter(widgets, {
                    instanceId: props.onlyInstanceId
                });
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.INSTAGRAM_INSIGHTS_FOLLOWER_LOCATIONS, InstagramFollowerLocations);

    const LinkedInSectionWidget = RivalIQ.views.LayoutView.mixin({
        template: '#insightsVerticalNormalizeHeightsTemplate2',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            top: '.x-top',
            bottom: '.x-bottom'
        },

        ui: {
            noDataMsgContainer: '.insights-no-data-msg-container',
            noDataMsg: '.insights-no-data-msg',
            dashboardRegions: '.dashboard-regions'
        },

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.getWidgets();
        },

        loadData: function () {
            const me = this;

            return App.utils.constructInsightsCompanyDataFetch(me.getProps())
                .then(function (cd) {
                    const company = cd.get(me.dashboardModel.getProp('companyId')).toJSON();
                    me.presenceData = RivalIQ.utils.companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.LINKEDIN, company);
                });
        },

        onBeforeRenderLoaded: function () {
            const me = this;
            me.collection.each(function (widget) {
                const region = widget.getRegion();
                me[region].showWidget(widget);
            });
        },

        onRenderLoaded: function () {
            const me = this;
            me.toggleViews();
        },

        toggleViews: function () {
            const me = this;

            // Look for one of the audience fields to see if we have data.
            const audienceDataAvailable = hasAudienceData(me.presenceData);
            const earliestAudienceDataDate = _.get(me.presenceData, ['presence', 'earliest_audience_data_date']);

            if (!audienceDataAvailable && earliestAudienceDataDate && moment.utc(me.getProp('timePeriod').mainPeriodEnd).isBefore(earliestAudienceDataDate)) {
                me.ui.dashboardRegions.hide();
                me.ui.noDataMsg.text(`No data in time periods prior to ${moment.utc(earliestAudienceDataDate).format('L')} (when you connected LinkedIn Analytics to Rival IQ)`);
                me.ui.noDataMsgContainer.show();
            } else {
                me.ui.dashboardRegions.show();
                me.ui.noDataMsgContainer.hide();
            }
        }
    });

    const LinkedInFollowerLocations = widgets.LinkedInFollowerLocations = App.widgets.InsightsSectionWidget.extend({
        title: RivalIQ.strings.linked_in_insights_follower_locations_title,
        view: LinkedInSectionWidget,
        description: RivalIQ.strings.linked_in_insights_follower_locations_widget_description,

        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.CSV
        ],

        csvExportProps: function (props) {
            const me = this;

            return {
                type: 'insights_demographics',
                companyId: props.companyId,
                sourceMask: RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.LINKEDIN].sourceMask,
                demographicTypes: ['country', 'city'],
                timePeriod: me.getProp('timePeriod')
            };
        },

        getSlides: function (overrides) {
            const me = this;
            return [
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'linkedin-countries'
                }, overrides)),
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'linkedin-cities'
                }, overrides))
            ];
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            let widgets = [
                {
                    instanceId: 'linkedin-countries',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'country',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.LINKEDIN
                    },
                    region: 'top'
                },
                {
                    instanceId: 'linkedin-cities',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'city',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.LINKEDIN
                    },
                    region: 'bottom'
                }
            ];

            if (props.onlyInstanceId) {
                widgets = _.filter(widgets, {
                    instanceId: props.onlyInstanceId
                });
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.LI_INSIGHTS_FOLLOWER_LOCATIONS, LinkedInFollowerLocations);


    const LinkedInFollowerDemographics = widgets.LinkedInFollowerDemographics = App.widgets.InsightsSectionWidget.extend({
        title: RivalIQ.strings.linked_in_insights_follower_demographics_title,
        view: LinkedInSectionWidget,
        description: RivalIQ.strings.linked_in_insights_follower_demographics_widget_description,

        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.CSV
        ],

        csvExportProps: function (props) {
            const me = this;

            return {
                type: 'insights_demographics',
                companyId: props.companyId,
                sourceMask: RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.LINKEDIN].sourceMask,
                demographicTypes: ['industry', 'job-function'],
                timePeriod: me.getProp('timePeriod')
            };
        },

        getSlides: function (overrides) {
            const me = this;
            return [
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'linkedin-industry'
                }, overrides)),
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'linkedin-job-function'
                }, overrides))
            ];
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            let widgets = [
                {
                    instanceId: 'linkedin-industry',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'industry',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.LINKEDIN
                    },
                    region: 'top'
                },
                {
                    instanceId: 'linkedin-job-function',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'job-function',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.LINKEDIN
                    },
                    region: 'bottom'
                }
            ];

            if (props.onlyInstanceId) {
                widgets = _.filter(widgets, {
                    instanceId: props.onlyInstanceId
                });
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.LI_INSIGHTS_FOLLOWER_DEMOGRAPHICS, LinkedInFollowerDemographics);

    const FacebookSectionWidget = RivalIQ.views.LayoutView.mixin({
        template: '#insightsVerticalNormalizeHeightsTemplate2',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        regions: {
            top: '.x-top',
            bottom: '.x-bottom'
        },

        ui: {
            noDataMsgContainer: '.insights-no-data-msg-container',
            noDataMsg: '.insights-no-data-msg',
            dashboardRegions: '.dashboard-regions'
        },

        initialize: function () {
            const me = this;

            me.collection = me.dashboardModel.getWidgets();
        },

        loadData: function () {
            const me = this;

            return App.utils.constructInsightsCompanyDataFetch(me.getProps())
                .then(function (cd) {
                    const company = cd.get(me.dashboardModel.getProp('companyId')).toJSON();
                    me.presenceData = RivalIQ.utils.companyDisplay.getSourcePrimaryRecord(RivalIQ.enums.sources.FACEBOOK_INSIGHTS, company);
                });
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            me.collection.each(function (widget) {
                const region = widget.getRegion();
                me[region].showWidget(widget);
            });
        },

        onRenderLoaded: function () {
            const me = this;
            me.toggleViews();
        },

        toggleViews: function () {
            const me = this;

            // Look for one of the audience fields to see if we have data.
            const audienceDataAvailable = hasAudienceData(me.presenceData);
            const earliestAudienceDataDate = _.get(me.presenceData, ['presence', 'earliest_audience_data_date']);

            if (!audienceDataAvailable && earliestAudienceDataDate && moment.utc(me.getProp('timePeriod').mainPeriodEnd).isBefore(earliestAudienceDataDate)) {
                me.ui.dashboardRegions.hide();
                me.ui.noDataMsg.text(`No data in time periods prior to ${moment.utc(earliestAudienceDataDate).format('L')} (when you connected Facebook Insights to Rival IQ)`);
                me.ui.noDataMsgContainer.show();
            } else {
                me.ui.dashboardRegions.show();
                me.ui.noDataMsgContainer.hide();
            }
        }
    });


    const FacebookInsightsPageFansLocations = App.widgets.InsightsSectionWidget.extend({
        title: RivalIQ.strings.facebook_insights_page_fans_locations_widget_title,
        view: FacebookSectionWidget,
        description: RivalIQ.strings.facebook_insights_page_fans_locations_widget_description,

        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.CSV
        ],

        csvExportProps: function (props) {
            const me = this;

            return {
                type: 'insights_demographics',
                companyId: props.companyId,
                sourceMask: RivalIQ.enums.sourceDetails[props.source].sourceMask,
                demographicTypes: ['fans-by-country', 'fans-by-city'],
                timePeriod: me.getProp('timePeriod')
            };
        },

        getSlides: function (overrides) {
            const me = this;
            return [
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'facebook-page-fans-country'
                }, overrides)),
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'facebook-page-fans-cities'
                }, overrides))
            ];
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            let widgets = [
                {
                    instanceId: 'facebook-page-fans-country',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'fans-by-country',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
                    },
                    region: 'top'
                },
                {
                    instanceId: 'facebook-page-fans-cities',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    props: {
                        demographicType: 'fans-by-city',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
                    },
                    region: 'bottom'
                }
            ];

            if (props.onlyInstanceId) {
                widgets = _.filter(widgets, {
                    instanceId: props.onlyInstanceId
                });
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_PAGE_FANS_LOCATIONS, FacebookInsightsPageFansLocations);

    const FacebookInsightsPageImpressionsAndReachLocations = App.widgets.InsightsSectionWidget.extend({
        title: RivalIQ.strings.facebook_insights_page_impressions_and_reach_locations_widget_title,
        view: FacebookSectionWidget,
        description: RivalIQ.strings.facebook_insights_page_impressions_and_reach_locations_widget_description,

        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PNG,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.CSV
        ],

        csvExportProps: function (props) {
            const me = this;

            return {
                type: 'insights_demographics',
                companyId: props.companyId,
                sourceMask: RivalIQ.enums.sourceDetails[props.source].sourceMask,
                demographicTypes: ['reach-by-country', 'reach-by-city'],
                timePeriod: me.getProp('timePeriod')
            };
        },

        getSlides: function (overrides) {
            const me = this;
            return [
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'facebook-average-unique-daily-reach-countries'
                }, overrides)),
                me.buildSlide(_.defaults({
                    onlyInstanceId: 'facebook-average-unique-daily-reach-cities'
                }, overrides))
            ];
        },

        widgetDefinitions: function () {
            const me = this;
            const props = me.getProps();

            let widgets = [
                {
                    instanceId: 'facebook-average-unique-daily-reach-countries',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    metricGroupType: 'impressions',
                    props: {
                        demographicType: 'reach-by-country',
                        companyId: props.companyId,
                        source: RivalIQ.enums.sources.FACEBOOK_INSIGHTS
                    },
                    region: 'top'
                },
                {
                    instanceId: 'facebook-average-unique-daily-reach-cities',
                    widgetId: widgetTypes.INSIGHTS_DEMOGRAPHICS,
                    metricGroupType: 'impressions',
                    props: {
                        demographicType: 'reach-by-city',
                        companyId: props.companyId
                    },
                    region: 'bottom'
                }
            ];

            if (props.onlyInstanceId) {
                widgets = _.filter(widgets, {
                    instanceId: props.onlyInstanceId
                });
            }

            return widgets;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FB_INSIGHTS_PAGE_IMPRESSIONS_AND_REACH_LOCATIONS, FacebookInsightsPageImpressionsAndReachLocations);

}, window.moment);
